import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ScrollPage } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/feedback/PageHeader';
import { Navigate } from 'react-router-dom';
import { BASE_PERMISSION } from '@/lib/constants/modules';
import { usePermission } from '@/lib/permissions/use-permission';
import { TtsHistoryPanel } from '../components/TtsHistoryPanel';

export function TtsListPage() {
  const canView = usePermission('Voice Library.TTS List', BASE_PERMISSION.VIEW);
  const canDelete = usePermission('Voice Library.TTS List', BASE_PERMISSION.DELETE);

  if (!canView) return <Navigate to="/voice-files" replace />;

  return (
    <ScrollPage>
      <PageHeader
        title="TTS Clips"
        description="Every TTS render you've created. Save the pending ones to the library, or discard them."
        actions={
          <Button asChild variant="outline">
            <Link to="/voice-files">
              <ArrowRight className="h-4 w-4" />
              Voice library
            </Link>
          </Button>
        }
      />

      <TtsHistoryPanel paginated canDelete={canDelete} />
    </ScrollPage>
  );
}
